// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"styles_checkboxContainer__Aknt6","personalData":"styles_personalData__4kXzz","label":"styles_label__s6ejx"};